module.exports = __webpack_public_path__ + "img/sld_scb_9_t1_green.239da426.svg";